<button
  #button
  type="button"
  class="flex items-center"
  [attr.aria-haspopup]="datepicker ? 'dialog' : null"
  [attr.aria-label]="ariaLabel || _intl.openCalendarLabel"
  [attr.tabindex]="disabled ? -1 : tabIndex"
  [disabled]="disabled"
>
  <svg-icon key="calendar-24" class="text-action-primary"></svg-icon>
  <ng-content select="[matDatepickerToggleIcon]"></ng-content>
</button>
